import { IonButton, IonContent } from "@ionic/react";
import { useState } from "react";
import { useHistory } from "react-router";
import { useRecoilState } from "recoil";
import {
  duplicateExercisePlanState,
  isDuplicateCalledState,
  newDuplicateExercisePlanState,
} from "../../data/atoms";

interface Props {
  setDeleteExerciseModal: Function;
  exerciseData: any;
  id: number;
}
const DeleteExerciseModal: React.FC<Props> = ({
  setDeleteExerciseModal,
  exerciseData,
  id,
}) => {
  const [duplicateExercisePlan, setDuplicateExercisePlan] = useRecoilState(
    duplicateExercisePlanState
  );
  // const [newDuplicateExercisePlan, setNewDuplicateExercisePlan] =
  //   useRecoilState(newDuplicateExercisePlanState);

  let history = useHistory();

  const DeleteExercisefromPlan = () => {
    debugger;
    setDuplicateExercisePlan((prevState: any) => ({
      ...prevState,
      exercises: duplicateExercisePlan.exercises.filter(
        (exercise: any) => exercise.testExercises[0].id !== id
      ),
    }));
    // setNewDuplicateExercisePlan((prevState: any) => ({
    //   ...prevState,
    //   exercises: newDuplicateExercisePlan.exercises.filter(
    //     (exercise: any) => exercise.testExercises[0].id !== id
    //   ),
    // }));
    const filterId = JSON.parse(localStorage.getItem("selectedExercises")!);
    if (filterId != null) {
      localStorage.setItem(
        "selectedExercises",
        JSON.stringify(filterId.filter((item: any) => item !== id))
      );
    }
    setDeleteExerciseModal(false);
  };

  return (
    <div className="all-generic-new-modal-center w-468-for-modal">
      <div className="delete-exercise-modal">
        <div className="cross-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19"
            height="19"
            viewBox="0 0 19 19"
            fill="none"
            onClick={() => setDeleteExerciseModal(false)}
          >
            <path
              d="M15.9999 15.9999L3 3"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M16 3L3 16"
              stroke="#D1D1D1"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <svg
          width="102"
          height="113"
          viewBox="0 0 102 113"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M40.19 39.2594C43.6418 39.2594 46.44 42.0577 46.44 45.5094L46.44 84.3983C46.44 87.8501 43.6418 90.6483 40.19 90.6483C36.7383 90.6483 33.94 87.8501 33.94 84.3983L33.94 45.5094C33.94 42.0577 36.7383 39.2594 40.19 39.2594Z"
            fill="#802392"
          />
          <path
            d="M62.4122 39.2594C65.864 39.2594 68.6622 42.0577 68.6622 45.5094V84.3983C68.6622 87.8501 65.8639 90.6483 62.4122 90.6483C58.9604 90.6483 56.1622 87.8501 56.1622 84.3983V45.5094C56.1622 42.0577 58.9604 39.2594 62.4122 39.2594Z"
            fill="#802392"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M34.6349 0.370895C28.1149 0.370895 22.8293 5.65642 22.8293 12.1765V17.0365H6.85645C3.40467 17.0365 0.606445 19.8348 0.606445 23.2865C0.606445 26.7383 3.40467 29.5365 6.85645 29.5365H11.7179V101.064C11.7179 107.584 17.0034 112.87 23.5234 112.87H79.079C85.599 112.87 90.8846 107.584 90.8846 101.064V29.5365H95.7453C99.1971 29.5365 101.995 26.7383 101.995 23.2865C101.995 19.8348 99.1971 17.0365 95.7453 17.0365H79.7738V12.1765C79.7738 5.65642 74.4883 0.370895 67.9682 0.370895H34.6349ZM28.9653 29.5365C29.0032 29.5372 29.0413 29.5376 29.0793 29.5376H73.5238C73.5619 29.5376 73.5999 29.5372 73.6378 29.5365H78.3846V100.37H24.2179V29.5365H28.9653ZM67.2738 17.0365V12.8709H35.3293V17.0365H67.2738Z"
            fill="#802392"
          />
        </svg>

        <h2>Are you sure you want to delete the exercise?</h2>

        <div className="btn-wrap-sec two-btns">
          <IonButton
            className="generic-btn generic-btn-outline"
            onClick={() => {
              setDeleteExerciseModal(false);
            }}
            placeholder={undefined}
          >
            Cancel
          </IonButton>
          <IonButton
            className="generic-btn"
            placeholder={undefined}
            onClick={() => {
              DeleteExercisefromPlan();
            }}
          >
            Delete
          </IonButton>
        </div>
      </div>
    </div>
  );
};
export default DeleteExerciseModal;
